import { render, staticRenderFns } from "./WidgetsCustomer.vue?vue&type=template&id=6319c82c"
import script from "./WidgetsCustomer.vue?vue&type=script&lang=js"
export * from "./WidgetsCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports